import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    inject,
    Input,
} from '@angular/core';
import { TenantProvider } from '@pf/shared-common';
import { take } from 'rxjs';

enum BarcodeFormat {
    QRCODE = 'QRCODE',
    CODE128 = 'CODE128',
    CODE128A = 'CODE128A',
    CODE128B = 'CODE128B',
    CODE128C = 'CODE128C',
    EAN13 = 'EAN13',
    UPC = 'UPC',
    EAN8 = 'EAN8',
    EAN5 = 'EAN5',
    EAN2 = 'EAN2',
    CODE39 = 'CODE39',
    ITF = 'ITF',
    ITF14 = 'ITF14',
    MSI = 'MSI',
    MSI10 = 'MSI10',
    MSI11 = 'MSI11',
    MSI1010 = 'MSI1010',
    MSI1110 = 'MSI1110',
    pharmacode = 'pharmacode',
    codabar = 'codabar',
}

const DEFAULT_BARCODE_FORMAT: BarcodeFormat = BarcodeFormat.CODE128;

@Component({
    selector: 'platform-barcode',
    templateUrl: './barcode.component.html',
    styleUrls: ['./barcode.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class BarcodeComponent {
    @Input() barcodeValue = '';
    @Input() displayValue = false;
    barcodeFormat: string = BarcodeFormat[DEFAULT_BARCODE_FORMAT];

    constructor() {
        const tenantProvider = inject(TenantProvider);
        const cdr = inject(ChangeDetectorRef);

        tenantProvider.localization$.pipe(take(1)).subscribe(localization => {
            const localeFormat =
                (localization.barcodeFormat as BarcodeFormat) ||
                DEFAULT_BARCODE_FORMAT;
            this.barcodeFormat =
                BarcodeFormat[localeFormat] ||
                BarcodeFormat[
                    (
                        localization.barcodeFormat as string
                    ).toUpperCase() as BarcodeFormat
                ];
            cdr.markForCheck();
        });
    }
}
